/**
 * Centralized scroll lock for modals and overlays.
 * Uses a ref count so body scroll is only restored when the last lock is released
 * (e.g. when the last modal in a stack closes).
 */
class ScrollLockManager {
  constructor() {
    this.lockCount = 0;
  }

  lock() {
    this.lockCount++;
    if (this.lockCount === 1) {
      document.body.style.overflow = "hidden";
    }
  }

  unlock() {
    if (this.lockCount <= 0) {
      const message =
        "scrollLock: unlock() called with no matching lock (lockCount already 0). Check that every lock() has a corresponding unlock().";
      if (typeof process !== "undefined" && process.env.NODE_ENV === "development") {
        throw new Error(message);
      }
      console.error(message);
      return;
    }
    this.lockCount--;
    if (this.lockCount === 0) {
      document.body.style.overflow = "";
    }
  }

  /**
   * Force reset (e.g. for edge cases or tests).
   * Sets count to 0 and restores body overflow.
   */
  reset() {
    this.lockCount = 0;
    document.body.style.overflow = "";
  }
}

export const scrollLockManager = new ScrollLockManager();
